import { Fireworks } from 'fireworks-js';
import $ from 'jquery';

export default class FireWorks {
  constructor(containerSelector = '.js-fireworks') {
    this.$container = document.querySelector(containerSelector);
    this.fireworksDuration = 15000;

    if ($(containerSelector).data('fireworks-duration')) {
      this.fireworksDuration = Number($(containerSelector).data('fireworks-duration')) * 1000;
    }

    this.init();
  }

  init() {
    this.initialized = true;

    if (!this.$container) {
      this.initialized = false;
      return;
    }

    this.fireworks = new Fireworks(this.$container, {
      acceleration: 1.02,
      hue: {
        min: 193,
        max: 305,
      },
      lineWidth: {
        explosion: {
          min: 1,
          max: 4,
        },
      },
      brightness: {
        min: 50,
        max: 80,
      },
      intensity: 50,
      explosion: 8,
      sound: {
        enable: false,
      },
      particles: 100,
      decay: {
        min: 0.015,
        max: 0.030,
      },
      opacity: 0.4,
      gravity: 1,
      friction: 0.98,
    });

    this.fireworksStart();

    setTimeout(() => {
      this.fireworksStop();
    }, this.fireworksDuration);

    this.attachEvents();
  }

  attachEvents() {
    $(this.$container).on('click', () => {
      $(this.$container).hide();
    });
  }

  fireworksStart() {
    this.fireworks.start();
  }

  fireworksStop() {
    this.fireworks.stop();
    $(this.$container).hide();
  }
}
